export const locations = {
  home: '/',
  signIn: '/sign-in',
  loggedInRedirect: '/datasets',
  optimizationProcesses: '/optimization-processes',
  optimizationProcess: (optimizationProcessId: number) =>
    `/optimization-processes/${optimizationProcessId}`,
  optimizationProcessDetails: (optimizationProcessId: number) =>
    `/optimization-processes/${optimizationProcessId}/details`,
  optimizationTasks: (
    optimizationProcessId: number,
    salesOrderId: number,
    salesOrdersLineId: number
  ) =>
    `/optimization-processes/${optimizationProcessId}/sales-orders/${salesOrderId}/lines/${salesOrdersLineId}/tasks`,
  settings: '/settings',
  workCenters: '/work-centers',
  workCenter: (workCenterId: number) => `/work-centers/${workCenterId}`,
  datasets: '/datasets',
  dataset: (datasetId: number) => `/datasets/${datasetId}`,
  editdatasets: (datasetId: number) => `/editdatasets/${datasetId}`,
}
